import {API} from "../api/axios";

const END_POINT = "/parents";
const END_POINT_PARENT = "/parent";
const END_POINT_VERSION = "/app-version";
const END_POINT_ENABLE = "/enable-disable-parent";

class ParentService {
  getAll(params) {
    return API.get(END_POINT, params);
  }
  getVersion(params) {
    return API.get(END_POINT_VERSION, params);
  }
  update(id, data) {
    return API.post(`${END_POINT_PARENT}/${id}`, data);
  }
  delete(id) {
    return API.delete(`${END_POINT_PARENT}/${id}`);
  }
  enableParent(id, data) {
    return API.post(`${END_POINT_ENABLE}/${id}`, data);
  }
  get(id, params) {
    return API.get(`${END_POINT_PARENT}/${id}`, params);
  }
}

export default new ParentService();
